export default __webpack_public_path__ + "static/media/proj15-cover.44fc7837.png";